import { EditPage, EditPageTextField, EditPagePanel, EditPageSelect, EditPageCheckbox } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const BranchesEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({ companies: [] });
    const navigate = useNavigate();
    const { branchId } = useParams();

    useEffect(() => {
        getOne('/admin/clients/branches/', branchId).then(response => {
            setData(response.data.data);
        });
        getOne('/admin/clients/branches/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, [branchId]);

    const handleSave = () => {
        update('/admin/clients/branches/', branchId, { data }).then(response => {
            toast.success('Branch updated successfully', {});
            navigate('/clients/branches');
        }).catch(error => {
            toast.error('Error updating branch: ' + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/clients/branches');
    };

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    };

    return (
        <div>
            <ToastContainer />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Edit Branch">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={onChange} value={data.name} required={true} />
                    <EditPageSelect
                        label="Company"
                        id="company_id"
                        onChange={onChange}
                        value={data.company_id}
                        options={Object.fromEntries((metadata.companies || []).map(c => [c.id, c.name]))}
                        required={true}
                    />
                    <EditPageTextField label="Address" id="address" onChange={onChange} value={data.address} />
                    <EditPageTextField label="City" id="city" onChange={onChange} value={data.city} />
                    <EditPageTextField label="State" id="state" onChange={onChange} value={data.state} />
                    <EditPageTextField label="ZIP" id="zip" onChange={onChange} value={data.zip} />
                    <EditPageTextField label="Country" id="country" onChange={onChange} value={data.country} />
                    <EditPageTextField label="Phone" id="phone" onChange={onChange} value={data.phone} />
                    <EditPageTextField label="Email" id="email" onChange={onChange} value={data.email} />
                    <EditPageCheckbox label="Status" id="status" onChange={onChange} value={data.status} options={[{ value: true, label: 'Active' }, { value: false, label: 'Inactive' }]} />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default BranchesEdit; 